// extracted by mini-css-extract-plugin
module.exports = {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__MhzJm","player":"MediaSideBar_player__r6-Jl"};